<div [formGroup]="parentFormGroup">
  <input
    pInputText
    [type]="inputType"
    [formControlName]="controlName"
    [ngClass]="{'ng-invalid ng-dirty': invalidCondition}" />
</div>
